import React from "react";
import { Link } from "react-router-dom";
const Campuscare = () => {
  return (
    <>
      <div className="campuslogo">
        <Link to="https://portalguidelines.campuscare.info/index.html#FAJSBL" target="_blank">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Campulogo.png"
            className="img-fluid float-end campus"
            alt="Frank Anthony Bangalore"
          />
        </Link>
      </div>
    </>
  );
};

export default Campuscare;
